import React from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const ContactInfoStep = ({ formData, errors, onChange }) => {
  const stateOptions = [
    { value: 'abia', label: 'Abia' },
    { value: 'adamawa', label: 'Adamawa' },
    { value: 'akwa-ibom', label: 'Akwa Ibom' },
    { value: 'anambra', label: 'Anambra' },
    { value: 'bauchi', label: 'Bauchi' },
    { value: 'bayelsa', label: 'Bayelsa' },
    { value: 'benue', label: 'Benue' },
    { value: 'borno', label: 'Borno' },
    { value: 'cross-river', label: 'Cross River' },
    { value: 'delta', label: 'Delta' },
    { value: 'ebonyi', label: 'Ebonyi' },
    { value: 'edo', label: 'Edo' },
    { value: 'ekiti', label: 'Ekiti' },
    { value: 'enugu', label: 'Enugu' },
    { value: 'fct', label: 'Federal Capital Territory' },
    { value: 'gombe', label: 'Gombe' },
    { value: 'imo', label: 'Imo' },
    { value: 'jigawa', label: 'Jigawa' },
    { value: 'kaduna', label: 'Kaduna' },
    { value: 'kano', label: 'Kano' },
    { value: 'katsina', label: 'Katsina' },
    { value: 'kebbi', label: 'Kebbi' },
    { value: 'kogi', label: 'Kogi' },
    { value: 'kwara', label: 'Kwara' },
    { value: 'lagos', label: 'Lagos' },
    { value: 'nasarawa', label: 'Nasarawa' },
    { value: 'niger', label: 'Niger' },
    { value: 'ogun', label: 'Ogun' },
    { value: 'ondo', label: 'Ondo' },
    { value: 'osun', label: 'Osun' },
    { value: 'oyo', label: 'Oyo' },
    { value: 'plateau', label: 'Plateau' },
    { value: 'rivers', label: 'Rivers' },
    { value: 'sokoto', label: 'Sokoto' },
    { value: 'taraba', label: 'Taraba' },
    { value: 'yobe', label: 'Yobe' },
    { value: 'zamfara', label: 'Zamfara' }
  ];

  return (
    <div className="space-y-6">
      <div className="bg-violet-50 border border-violet-200 rounded-lg p-4">
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 bg-violet-500 rounded-full flex items-center justify-center flex-shrink-0">
            <span className="text-white text-lg">📧</span>
          </div>
          <div>
            <h3 className="text-lg font-semibold text-gray-900 mb-1">Contact Information</h3>
            <p className="text-sm text-gray-600">
              Provide your contact details and current address. We'll use this information to reach you.
            </p>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Input
          label="Email Address"
          type="email"
          value={formData?.email}
          onChange={(e) => onChange('email', e?.target?.value)}
          error={errors?.email}
          required
          placeholder="your.email@example.com"
          description="We'll never share your email"
        />

        <Input
          label="Phone Number"
          type="tel"
          value={formData?.phone}
          onChange={(e) => onChange('phone', e?.target?.value)}
          error={errors?.phone}
          required
          placeholder="08012345678"
          description="Format: 11 digits starting with 07, 08, or 09"
        />

        <Input
          label="Alternative Phone Number"
          type="tel"
          value={formData?.alternativePhone}
          onChange={(e) => onChange('alternativePhone', e?.target?.value)}
          placeholder="08012345678 (optional)"
        />

        <Input
          label="WhatsApp Number"
          type="tel"
          value={formData?.whatsappNumber}
          onChange={(e) => onChange('whatsappNumber', e?.target?.value)}
          placeholder="08012345678 (optional)"
        />
      </div>
      <div className="border-t border-gray-200 pt-6">
        <h4 className="text-md font-semibold text-gray-900 mb-4">Residential Address</h4>
        <div className="grid grid-cols-1 gap-6">
          <Input
            label="Street Address"
            type="text"
            value={formData?.streetAddress}
            onChange={(e) => onChange('streetAddress', e?.target?.value)}
            error={errors?.streetAddress}
            required
            placeholder="Enter your street address"
          />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <Input
              label="City"
              type="text"
              value={formData?.city}
              onChange={(e) => onChange('city', e?.target?.value)}
              error={errors?.city}
              required
              placeholder="Enter city"
            />

            <Select
              label="State"
              options={stateOptions}
              value={formData?.state}
              onChange={(value) => onChange('state', value)}
              error={errors?.state}
              required
              searchable
              placeholder="Select state"
            />

            <Input
              label="Postal Code"
              type="text"
              value={formData?.postalCode}
              onChange={(e) => onChange('postalCode', e?.target?.value)}
              placeholder="Enter postal code (optional)"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactInfoStep;